module.exports = __webpack_public_path__ + "static/media/intro-photowall-15.b1689be9.jpg";